// NOTE: This file must remain a JS file because
// it's used in `vite.config.js`

export const VERSION = '2.4.0'
export const RELEASE_TIME = 1753168438567
